import { i18n } from '../translate/i18n';
import moment from 'moment';

const statusLabelMaintenance = (status, props = '') => {

  // status scheduled: pode ser agendada ou pendente.
  // status progress: pode ser em progresso ou em atraso.
  // status completed: pode ser concluida ou vencida.

  switch (status) {
    case 'progress':
      if(status === 'progress' && new Date() > moment(new Date(props?.returnFromMaintenanceDate)).endOf('day').toDate()) {
        return {
          title: i18n.t('maintenancesStatusLabel.title6'), // Em Atraso
          color: 'red'
        }
      } else {
        return {
          title: i18n.t('maintenancesStatusLabel.title'), // Em Progresso
          color: '#ffd700'
        }
      }

    case 'completed' :
      if(status === 'completed' && props?.expiration !== null && new Date() > moment(new Date(props?.expiration)).endOf('day').toDate()) {
        return {
          title: i18n.t('maintenancesStatusLabel.title5'), // Vencida
          color: 'red'
        }
      } else {
        return {
          title: i18n.t('maintenancesStatusLabel.title2'), // Concluída
          color: 'green'
        }
      }
      
    case 'scheduled':
      if(new Date() < moment(new Date(props?.sendToMaintenanceDate)).endOf('day').toDate()) {
        return {
          title: i18n.t('maintenancesStatusLabel.title3'), // Agendada
          color: '#457CDA'
        }
      } else {
        return {
          title: i18n.t('maintenancesStatusLabel.title4'), // Pendente
          color: 'red'
        }
      }

    case 'canceled':
      return {
        title: i18n.t('maintenancesStatusLabel.title1'), // Cancelada
        color: 'black'
      }

    default:
      return {
        title: 'Manutenção sem Status',
        color: 'grey'
      }
  }
}

export default statusLabelMaintenance;
